import { render, staticRenderFns } from "./LoteDetergente.vue?vue&type=template&id=e31876cc&"
import script from "./LoteDetergente.vue?vue&type=script&lang=js&"
export * from "./LoteDetergente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports